import '@ant-design/compatible/assets/index.css';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { fireCustomEvent } from '~helpers/custom-events';
import CommissionPlanList from '~pages/dashboard/referral/commission-plan/list';

@withTranslation()
class CommissionPlan extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  getCurrentRole = () => {
    if (
      this.props.auth &&
      this.props.auth.currentRoleSlug &&
      this.state.userInfo &&
      this.state.userInfo.userRoles
    ) {
      return this.state.userInfo.userRoles.find(
        role => role.slug === this.props.auth.currentRoleSlug,
      );
    }
    return null;
  };

  handleSwitchRole = () => {
    fireCustomEvent('triggerSwitchRole');
  };

  render() {
    return <CommissionPlanList />;
  }
}

export default CommissionPlan;

CommissionPlan.propTypes = {
  t: PropTypes.func,
  history: PropTypes.object,
  auth: PropTypes.shape({
    currentRoleSlug: PropTypes.string,
  }),
  cmsUser: PropTypes.object,
};

CommissionPlan.defaultProps = {
  t: () => {},
  history: '',
  auth: {},
  cmsUser: {},
};
